export type AttachMethod = "picker" | "drop" | "paste"

const attachMethodByFile = new WeakMap<File, AttachMethod>()

export function tagAttachMethod(file: File, method: AttachMethod): void {
  attachMethodByFile.set(file, method)
}

export function getAttachMethod(file: File): AttachMethod {
  return attachMethodByFile.get(file) ?? "picker"
}
